module.exports = __webpack_public_path__ + "img/elite_dark_brown_ba_list.fff38b57.jpg";